export default "__VITE_ASSET__07bbe984__"